function formatDate(date) {
  if (date) {
    const formattedDate = new Date(date).toLocaleString();
    return formattedDate;
  }
  return undefined;
}

export default formatDate;
